import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = {
  class: "flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat h-screen",
  style: {"background-color":"#3F403E"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pb-5 flex flex-col items-center max-h-full" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "max-h-full object-contain w-4/12",
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createElementVNode("h1", {
    class: "font-bold text-3xl w-full text-center text-white mt-5 pt-5",
    style: {"font-family":"Martin"}
  }, "MUCHAS GRACIAS POR INSCRIBIRSE A CAPER SHOW 2024")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, _hoisted_3))
}